import { PublicUser } from "common/build/prisma/client";
import { getData, postData } from "../rest";

export const get = async (): Promise<PublicUser> => await getData("/public/auth");

export const loginUser = async (token: string): Promise<Response> => await postData(`/public/auth`, { token });

export const sendMagicLinkEmail = async (email: string): Promise<Response> =>
    await postData(`/public/auth/send-magic-link`, { email });
